<template>
  <div>
    <v-alert
      prominent
      type="error"
      v-if="loginErrorAlert"
      transition="scale-transition"
      @click="loginErrorAlert = !loginErrorAlert"
    >
      <!-- ログイン失敗アラート -->
      <v-col class="grow">{{ this.texts.login_failure }}</v-col>
    </v-alert>
    <div v-on:click="passwordRegistAlert = false">
      <v-alert
        prominent
        type="error"
        v-if="passwordRegistAlert"
        transition="scale-transition"
      >
        <!-- パスワード登録失敗アラート -->
        <v-col class="grow">{{ this.texts.password_regulation }}</v-col>
      </v-alert>

      <v-alert
        prominent
        type="error"
        v-if="matchPassword == 'not match'"
        transition="scale-transition"
      >
        <!-- パスワード登録失敗アラート - 不一致 -->
        <v-col class="grow">{{ this.texts.not_match_password }}</v-col>
      </v-alert>

      <v-alert
        prominent
        type="error"
        v-if="matchPassword == 'too long'"
        transition="scale-transition"
      >
        <!-- パスワード登録失敗アラート -長すぎる- -->
        <v-col class="grow">パスワードは16文字以下に設定してください</v-col>
      </v-alert>
    </div>

    <!-- 通常ログイン -->
    <h2 class="auth_ttl">
      {{
        getFormState === "signIn" ? this.texts.signIn : this.texts.newPassword
      }}
    </h2>
    <br />
    <!-- IDログインフォーム（IDのみに統一） -->
    <div class="formcontainer" v-if="getFormState == 'signIn'">
      <p id="form-label">{{ this.texts.idEmailLabel }}</p>
      <v-text-field v-model="loginForm.username" solo></v-text-field>
      <p id="form-label">{{ this.texts.password }}</p>
      <v-text-field
        solo
        v-model="loginForm.password"
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show2 ? 'text' : 'password'"
        name="input-10-2"
        :hint="this.texts.password_hint"
        class="input-group--focused"
        @click:append="show2 = !show2"
      ></v-text-field>
      <p class="mail_text">
        {{ this.texts.password_forgot_1
        }}<a href="mailto:suiminhensachi@brain-sleep.com"
          >suiminhensachi@brain-sleep.com</a
        >{{ this.texts.password_forgot_2 }}
      </p>
      <div class="auth_btnArea">
        <button class="btn_next" v-on:click="signIn">
          {{ this.texts.signIn }}
        </button>
      </div>
    </div>
    <!-- 初期パスワードの設定 -->
    <div class="formcontainer" v-if="getFormState == 'forceChangePassword'">
      <p id="form-label">{{ this.texts.first_login }}</p>
      {{ this.texts.password }}
      <v-text-field
        solo
        v-model="loginForm.password"
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show2 ? 'text' : 'password'"
        name="input-10-2"
        :hint="this.texts.password_hint"
        class="input-group--focused"
        @click:append="show2 = !show2"
      ></v-text-field>
      {{ this.texts.password_confirm }}
      <v-text-field
        solo
        v-model="loginForm.passwordConfirm"
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show2 ? 'text' : 'password'"
        name="input-10-2"
        :hint="this.texts.password_hint"
        class="input-group--focused"
        @click:append="show2 = !show2"
      ></v-text-field>
      <div class="auth_btnArea">
        <button class="btn_next" v-on:click="changePassword">
          {{ this.texts.signIn }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Auth } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import configMail from "../aws-exports-mail.js";
import configId from "../aws-exports-id.js";
import loginTextJa from "../assets/LoginTextsJa";
import loginTextEn from "../assets/LoginTextsEn";
import loginTextCh from "../assets/LoginTextsCh";
import aesEcb from "aes-ecb";
Vue.use(AmplifyPlugin, AmplifyModules);

export default {
  name: "home",
  beforeMount() {
    const params = new URLSearchParams(window.location.search);
    let paramInfo = {};
    for (const param of params) {
      paramInfo[param[0]] = param[1];
    }

    // URLパラメータ(u,p,lt)による自動ログイン時のみltに応じて設定、それ以外はID用に統一
    const hasAutoLoginParams =
      "u" in paramInfo && "p" in paramInfo && paramInfo["lt"] !== "id";
    if (hasAutoLoginParams) {
      Amplify.configure(configMail);
    } else {
      this.changeLoginForId();
    }
  },
  created() {
    localStorage.setItem("susiminhensachiLoginType", "id");
    // eslint-disable-next-line
    if (this.getLanguage == "日本語") {
      // eslint-disable-next-line
      this.texts = loginTextJa;
    } else if (this.getLanguage == "English") {
      // eslint-disable-next-line
      this.texts = loginTextEn;
    } else if (this.getLanguage == "中文") {
      // eslint-disable-next-line
      this.texts = loginTextCh;
    }
    const params = new URLSearchParams(window.location.search);
    let paramInfo = {};
    for (const param of params) {
      paramInfo[param[0]] = param[1];
    }

    // VideoPath指定が存在する場合は、フラグをtrueにする
    if (paramInfo["tv"] == 1) {
      this.isToVideoTop = true;
    }

    if (
      ("u" in paramInfo) &
      ("p" in paramInfo) &
      (paramInfo["lt"] == "email" || "lt" in paramInfo == false)
    ) {
      // eslint-disable-next-line
      console.log("TRY EMAIL LOGIN!");
      this.loginForm.username = aesEcb.decrypt(
        "ntbsocKEY511XYZX",
        decodeURI(paramInfo["u"].replaceAll(" ", "+"))
      );
      this.loginForm.password = aesEcb.decrypt(
        "ntbsocKEY511XYZX",
        decodeURI(paramInfo["p"].replaceAll(" ", "+"))
      );
      this.loginType = "email";
      Amplify.configure(configMail);
      this.signIn();
    } else if (
      ("u" in paramInfo) &
      ("p" in paramInfo) &
      (paramInfo["lt"] == "id")
    ) {
      // eslint-disable-next-line
      console.log("TRY ID LOGIN!");
      this.loginForm.username = aesEcb.decrypt(
        "ntbsocKEY511XYZX",
        decodeURI(paramInfo["u"].replaceAll(" ", "+"))
      );
      this.loginForm.password = aesEcb.decrypt(
        "ntbsocKEY511XYZX",
        decodeURI(paramInfo["p"].replaceAll(" ", "+"))
      );
      this.loginType = "id";
      Amplify.configure(configId);
      this.signIn();
    }
  },
  data() {
    return {
      show2: false,
      isToVideoTop: false,
      loginForm: {
        username: "",
        password: "",
        passwordConfirm: "",
      },
      user: "",
      loginErrorAlert: false,
      passwordRegistAlert: false,
      config: "config",
      texts: "",
      matchPassword: "",
      loginType: "id",
    };
  },
  computed: {
    returnLanguage() {
      return this.getLanguage;
    },
    ...mapGetters([
      "getFormState",
      "getLanguages",
      "getLanguage",
      "getLoginUserId",
    ]),
  },
  watch: {
    returnLanguage() {
      // eslint-disable-next-line
      if (this.getLanguage == "日本語") {
        // eslint-disable-next-line
        this.texts = loginTextJa;
      } else if (this.getLanguage == "English") {
        // eslint-disable-next-line
        this.texts = loginTextEn;
      } else if (this.getLanguage == "中文") {
        // eslint-disable-next-line
        this.texts = loginTextCh;
      }
    },
  },
  methods: {
    changeLoginForId() {
      Amplify.configure(configId);
      this.loginType = "id";
      // eslint-disable-next-line
      Vue.use(AmplifyPlugin, AmplifyModules);
    },
    ...mapMutations(["setValueToFormState", "setValueToLoginUserId"]),
    async signIn() {
      try {
        localStorage.setItem("susiminhensachiLoginType", this.loginType);
        const { username, password } = this.loginForm;
        this.user = await Auth.signIn(username, password);
        if (this.user.challengeName === "NEW_PASSWORD_REQUIRED") {
          this.loginForm.password = "";
          this.show2 = true;
          this.$store.commit("setValueToFormState", "forceChangePassword");
          return;
        }
        // eslint-disable-next-line
        console.log("users is...", this.user);
        Auth.currentSession()
          // eslint-disable-next-line
          .then((data) => {
            // eslint-disable-next-line
            this.$store.commit(
              "setValueToAccessToken",
              data["accessToken"]["jwtToken"]
            );
            this.$store.commit("setValueToLoginUserId", this.user.username);
            // eslint-disable-next-line
            console.log("user id is...", this.getLoginUserId);
            AmplifyEventBus.$emit("authState", "signedIn");
            if (this.isToVideoTop) {
              this.$router.push("/sleepTestTop");
            } else {
              this.$router.push("/mytop");
            }
          });
      } catch (err) {
        this.loginErrorAlert = true;
        return;
      }
    },
    async changePassword() {
      this.matchPassword = "";
      if (this.loginForm.password != this.loginForm.passwordConfirm) {
        this.matchPassword = "not match";
        return true;
      }
      if (this.loginForm.password.length >= 17) {
        this.matchPassword = "too long";
        return true;
      }
      try {
        const user = this.user;
        const password = this.loginForm.password;
        await Auth.completeNewPassword(user, password);
        this.$store.commit("setValueToFormState", "signIn");
        AmplifyEventBus.$emit("authState", "signedIn");
        this.$router.push("/mytop");
        return;
      } catch (err) {
        this.passwordRegistAlert = true;
        return;
      }
    },
    moveToPasswordReset() {
      this.$store.commit("setValueToFormState", "refreshPassword");
    },
  },
};
</script>

<style lang="scss">
$xs: "320px";
$sm: "480px";
$md: "800px";
.formcontainer {
  display: flex;
  flex-direction: column;
  width: 500px;
  margin-top: 50px;
  @media screen and (max-width: $md) {
    width: auto;
  }
}

#submit-btn {
  /* 文字サイズを1.4emに指定 */
  font-size: 0.8em;

  /* 文字の太さをboldに指定 */
  font-weight: bold;

  /* 文字色を白色に指定 */
  color: #fff;

  height: 48px;
}

#form-label {
  margin-bottom: 10px;
}

#form-top-label {
  margin-top: 40px;
}
.auth {
  &_ttl {
    color: #1d64a1;
    text-align: center;
  }
}
a {
  text-decoration: none;
}
.forgot_password {
  font-size: 14px;
  color: #1d64a1;
}
</style>
